<template>
  <div id="app" class="dark-theme">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Dark Theme Variables */
:root {
  --primary-gradient: linear-gradient(135deg, #4a90e2 0%, #5c6bc0 100%);
  --dark-bg: #1a1a1a;
  --dark-surface: #2d2d2d;
  --dark-surface-hover: #3a3a3a;
  --dark-border: #404040;
  --dark-text: #ffffff;
  --dark-text-muted: #b0b0b0;
  --dark-text-secondary: #888888;
}

/* Dark Theme Implementation */
.dark-theme {
  background-color: var(--dark-bg);
  color: var(--dark-text);
  min-height: 100vh;
}

/* Ensure all text is white by default in dark theme */
.dark-theme,
.dark-theme h1,
.dark-theme h2,
.dark-theme h3,
.dark-theme h4,
.dark-theme h5,
.dark-theme h6,
.dark-theme p,
.dark-theme span,
.dark-theme div,
.dark-theme label,
.dark-theme small {
  color: var(--dark-text) !important;
}

/* Override Bootstrap dark theme */
.dark-theme .navbar {
  background-color: var(--dark-surface) !important;
  border-bottom: 1px solid var(--dark-border);
}

.dark-theme .navbar-brand,
.dark-theme .nav-link {
  color: var(--dark-text) !important;
}

.dark-theme .dropdown-menu {
  background-color: var(--dark-surface);
  border: 1px solid var(--dark-border);
}

.dark-theme .dropdown-item {
  color: var(--dark-text);
}

.dark-theme .dropdown-item:hover {
  background-color: var(--dark-surface-hover);
}

.dark-theme .btn-outline-primary {
  color: #4a90e2;
  border-color: #4a90e2;
}

.dark-theme .btn-outline-primary:hover,
.dark-theme .btn-outline-primary.active {
  background-color: #4a90e2;
  border-color: #4a90e2;
  color: white;
}

.dark-theme .form-select {
  background-color: var(--dark-surface);
  border-color: var(--dark-border);
  color: var(--dark-text);
}

.dark-theme .form-control {
  background-color: var(--dark-surface);
  border-color: var(--dark-border);
  color: var(--dark-text);
}

.dark-theme .form-control:focus {
  background-color: var(--dark-surface);
  border-color: #4a90e2;
  color: var(--dark-text);
  box-shadow: 0 0 0 0.2rem rgba(74, 144, 226, 0.25);
}

.dark-theme .form-control::placeholder {
  color: var(--dark-text-muted);
}

.dark-theme .form-label {
  color: var(--dark-text) !important;
}

.dark-theme .form-text {
  color: var(--dark-text-muted) !important;
}

.dark-theme .card {
  background-color: var(--dark-surface);
  border-color: var(--dark-border);
  color: var(--dark-text);
}

.dark-theme .card-title,
.dark-theme .card-text,
.dark-theme .card-body,
.dark-theme .card-body * {
  color: var(--dark-text) !important;
}

.dark-theme .modal-content {
  background-color: var(--dark-surface);
  color: var(--dark-text);
}

.dark-theme .modal-header,
.dark-theme .modal-footer {
  border-color: var(--dark-border);
}

.dark-theme .table {
  color: var(--dark-text);
}

.dark-theme .table th,
.dark-theme .table td {
  color: var(--dark-text) !important;
  border-color: var(--dark-border);
}

.dark-theme .table thead th {
  color: var(--dark-text) !important;
  border-color: var(--dark-border);
  background-color: var(--dark-surface) !important;
}

.dark-theme .table-striped > tbody > tr:nth-of-type(odd) > td {
  background-color: var(--dark-surface-hover);
  color: var(--dark-text) !important;
}

.dark-theme .table-striped > tbody > tr:nth-of-type(even) > td {
  background-color: rgba(255, 255, 255, 0.05);
  color: var(--dark-text) !important;
}

/* Primary button with gradient */
.bg-primary {
  background: var(--primary-gradient) !important;
}

.btn-primary {
  background: var(--primary-gradient);
  border: none;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #3a7bc8 0%, #4a5ba6 100%);
  border: none;
}

/* Set body to dark theme globally */
body {
  background-color: var(--dark-bg);
  color: var(--dark-text);
}

/* Font Awesome icon replacements - remove old Bootstrap Icons fallbacks */

/* Text color overrides for dark theme */
.dark-theme .text-muted {
  color: var(--dark-text-muted) !important;
}

.dark-theme .text-secondary {
  color: var(--dark-text-secondary) !important;
}

.dark-theme .text-dark {
  color: var(--dark-text) !important;
}

.dark-theme .text-center,
.dark-theme .text-left,
.dark-theme .text-right {
  color: var(--dark-text) !important;
}

/* List group items in dark theme */
.dark-theme .list-group-item {
  background-color: var(--dark-surface);
  border-color: var(--dark-border);
  color: var(--dark-text);
}

.dark-theme .list-group-item:hover {
  background-color: var(--dark-surface-hover);
  color: var(--dark-text);
}

.dark-theme .list-group-item.active {
  background-color: #4a90e2;
  border-color: #4a90e2;
  color: white;
}

/* Alert components */
.dark-theme .alert {
  border-color: var(--dark-border);
}

.dark-theme .alert-info {
  background-color: rgba(74, 144, 226, 0.1);
  border-color: rgba(74, 144, 226, 0.2);
  color: var(--dark-text);
}

/* Spinner components */
.dark-theme .spinner-border {
  color: var(--dark-text-muted);
}
</style>
